import { IApplicationState } from '../../types/redux';
import { IMarkedListItem } from '../../types/seoData';

export const selectMarkedListItems = (state: IApplicationState): IMarkedListItem[] => {
  return state.seoData.markedList?.items || [];
};
